import e from"./custom-style.js";class t extends e{constructor(){super("empty",{})}overrideWith(r){return r}}export{t as default};
//# sourceMappingURL=empty-custom-style.js.map
